import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance145 = () => {
  return <IndividualTable matchType={"PRE"} gender="F" event="145" subTitle="Kungdo" data={sampleData2} topRankCount="16" />;
};
export default Distance145;
